<template>
    <div id="item">
        <router-link
        :to="{name: 'assets_index', params: {category: category}}"
        class="item"
        :class="{'active': is_activated}"
        v-on:click.native="set_current_category"
        >
            {{ category }}
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        category: String
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
        is_activated() {
            if (this.category == this.$store.state.provider.assets_module.current_category) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        set_current_category() {
            this.$store.state.provider.assets_module.current_category = this.category
        }
    },
    components: {
    }
}
</script>

<style scoped>
</style>
